import { getProduct, getProducts } from "../../../core/api/product";

import Layout from "../../../components/Layout";
import PageContentBrand from "../../../components/PageContentBrand";
import Product from "../../../components/Product";
import React from "react";
import { getBrand } from "../../../core/api/brand";
import { getFooter } from "../../../core/api/core";
import { getMenu } from "../../../core/api/menu";

function BrandProduct({ product, menuData, brandMenuData, globalData, brand }) {
  return (
    <Layout navItems={menuData} brand={brand} globalData={globalData}>
      <PageContentBrand brandMenuData={brandMenuData} brand={brand}>
        <Product
          product={product}
          metaDescription={`${product.brand.name} ${product.title}. ${
            brand.metaDescription ? brand.metaDescription.value : ""
          }`}
        />
      </PageContentBrand>
    </Layout>
  );
}

export default BrandProduct;

export async function getStaticProps({ params }) {
  const product = await getProduct(params.slug);
  if (!product) {
    return {
      notFound: true,
    };
  }
  const brand = await getBrand(params.brand);
  if (!brand) return { notFound: true };
  const menuData = await getMenu();
  const brandMenuData = await getMenu(params.brand);
  if (!brandMenuData) return { notFound: true };
  const globalData = await getFooter();

  return {
    props: {
      product,
      menuData,
      brandMenuData,
      brand,
      globalData,
    },
    revalidate: 300,
  };
}

export async function getStaticPaths() {
  const products = await getProducts();

  const paths = products.map((product) => ({
    params: {
      brand: product.brandSlug,
      slug: product.slug,
    },
  }));

  return {
    paths,
    fallback: "blocking",
  };
}
